export default __webpack_public_path__ + "static/media/smiley_heart_eyes.7b29e4a8.png";